import LabPage from "../components/layout/LabPage";
import { BookCopy, Wand2, Type, Layers, Box, Ruler, Image as ImageIcon, Barcode } from "lucide-react";

export default function CoverLab() {
  return (
    <LabPage
      testId="cover-lab-page"
      kicker="CoverLab"
      title="Covers and mockups that sell"
      description="Book, ebook, paperback wrap, hardcover, lead magnet, course, product, and 3D mockups — KDP-ready and brand-locked."
      heroImage="https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=900&q=80"
      heroTone="aqua"
      actions={[{ label: "Generate Cover", icon: Wand2, to: "/create" }]}
      quickActions={[
        { label: "Title Layout", icon: Type },
        { label: "Spine Calc", icon: Ruler },
        { label: "Background AI", icon: ImageIcon },
        { label: "3D Mockup", icon: Box },
      ]}
      features={[
        { icon: BookCopy, title: "All Cover Formats", description: "Ebook, paperback, hardcover, full-wrap, lead magnet." },
        { icon: Type, title: "Title & Subtitle Layout", description: "Author placement, hierarchy, kerning, ligatures." },
        { icon: Ruler, title: "Spine Calculator", description: "Auto computes spine width from page count and paper." },
        { icon: Barcode, title: "Barcode Safe Area", description: "ISBN barcode placement and KDP guides." },
        { icon: Layers, title: "Background System", description: "Faded logos, contour gradients, paper textures." },
        { icon: ImageIcon, title: "Image Generation", description: "Generate hero imagery via Nano Banana / image provider." },
      ]}
      sampleAssets={[
        { title: "Operator's Playbook · Cover", thumb: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=500&q=80", meta: "6x9 · Paperback" },
        { title: "Quiet Empire · Cover", thumb: "https://images.unsplash.com/photo-1532012197267-da84d127e765?w=500&q=80", meta: "5.5x8.5" },
        { title: "Cashflow Code · 3D", thumb: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=500&q=80", meta: "Mockup" },
        { title: "Lead Magnet Cover", thumb: "https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=500&q=80", meta: "Letter · PDF" },
      ]}
    />
  );
}
